export class UserContactInfo {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
}
